<script setup>
import { useAuthStore } from '~/stores/auth.js'
import { useImpersonation } from '~/composables/useImpersonation.js'

const { t } = useI18n()
const authStore = useAuthStore()
const { impersonating } = useImpersonation()

function exit() {
  authStore.logout()
  window.location.href = '/'
}
</script>

<template>
  <div
    v-if="impersonating"
    class="fixed inset-x-0 top-0 z-[9999] flex h-9 items-center justify-center gap-3 overflow-hidden whitespace-nowrap bg-amber-500 px-4 text-sm font-medium text-amber-950 shadow-[0_2px_12px_rgba(0,0,0,0.18)]"
    role="status"
  >
    <span class="truncate">{{ t('impersonation.banner', { email: authStore.user.email }) }}</span>
    <button
      type="button"
      class="shrink-0 rounded-full bg-amber-950 px-3 py-0.5 text-xs font-semibold text-amber-50 hover:bg-amber-900"
      @click="exit"
    >
      {{ t('impersonation.exit') }}
    </button>
  </div>
</template>
